export default __webpack_public_path__ + "static/media/Deployment.c7859d9e.png";